<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5 7.5L15.5 24.5L5.5 7.5L25.5 7.5Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'ChevronDown' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
